/** Two-paper Pearson sittings: TMUA, LNAT, and TSA (heritage under TARA). */

export function resolvePreStartAttemptExamName(examUpper) {
  const exam = String(examUpper || '').toUpperCase();
  if (exam === 'ESAT') return 'ESAT';
  if (exam === 'TARA') return 'TARA';
  return exam;
}

export function usesTwoPaperAttemptQuestions(examName, source = {}) {
  const exam = String(examName || '').toUpperCase();
  if (exam === 'TMUA' || exam === 'LNAT') return true;
  // TSA is a two-paper heritage sitting under TARA. Native TARA/BMAT use pearsonModules.
  return exam === 'TARA' && Boolean(source?.tsaSitting);
}
